export const USER_TYPES = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
};
